/* @flow */

import * as React from 'react';
import {Switch, Route, withRouter, type ContextRouter} from 'react-router-dom';

import {ExpiredPage} from './expired-page';
import {JoinYourTeamPage} from './join-your-team/join-your-team-page';
import {LoginRoot} from './login/login-root';
import {OldBrowserPage} from './old-browser-page';
import {PausedPage} from './paused-page';
import {SignupPage} from './signup/signup-page';
import {TinyIntroductionPage} from './tiny-introduction/tiny-introduction-page';
import {VerifyEmailPage} from './verify-email/verify-email-page';
import {VerifySenderPage} from './verify-sender/verify-sender-page';

type Props = ContextRouter;

/*
 * This is the top-level ui component for pages which are shown before authentication,
 * including signup, welcome screens, and login
 */

export class AuthRootComponent extends React.Component<Props> {
    componentDidMount(): void {
        this.props.history.listen((location) => {
            dataLayer.push({
                event: 'clientPageview',
                pageUrl: location.pathname,
            });
        });
    }

    render() {
        return (
            <Switch>
                <Route path='/auth/expired' component={ExpiredPage} />
                <Route path='/auth/paused' component={PausedPage} />
                <Route path='/auth/join-your-team' component={JoinYourTeamPage} />
                <Route path='/auth/old-browser' component={OldBrowserPage} />
                <Route path='/auth' component={LoginRoot} />
                <Route path='/my-account/verify-email' component={VerifyEmailPage} />
                <Route path='/email-verify/success' component={VerifySenderPage} />
                <Route path='/email-verify/failure' component={VerifySenderPage} />
                <Route
                    path='/signup/zendesksell'
                    render={(props) => <SignupPage {...props} signupStartPage={'ZENDESK_SELL'} />}
                />
                <Route path='/signup/:slideId' component={TinyIntroductionPage} />
                <Route
                    path='/signup'
                    render={(props) => <SignupPage {...props} signupStartPage={null} />}
                />
            </Switch>
        );
    }
}

export const AuthRoot = withRouter<{||}>(AuthRootComponent);
